import { render, staticRenderFns } from "./PageRestaurantsCreate.vue?vue&type=template&id=add427ee&scoped=true&"
import script from "./PageRestaurantsCreate.vue?vue&type=script&lang=ts&"
export * from "./PageRestaurantsCreate.vue?vue&type=script&lang=ts&"
import style0 from "./PageRestaurantsCreate.vue?vue&type=style&index=0&id=add427ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add427ee",
  null
  
)

export default component.exports